import React from "react";
import { useParams } from "react-router-dom";
import { links } from "../data/links";
import { Card, CardBody } from "reactstrap";
import {
    LineChart, Line, PieChart, Pie, Cell, XAxis, YAxis,
    CartesianGrid, Tooltip, ResponsiveContainer, Label
} from "recharts";
import { format, parse } from "date-fns";
import { ru } from "date-fns/locale";
const StatsPage = () => {
    const { id } = useParams();
    const link = links.find(l => l.id === id);
    if (!link) return <p className="text-center text-danger mt-5">Ссылка не найдена</p>;
    const formattedData = link.chart.map(item => ({
        ...item,
        formattedTime: format(parse(item.time, "yyyy-MM-dd HH:mm", new Date()), "d MMM, HH:mm", { locale: ru })
    }));
    return (
        <div className="container py-5">
            <h2 className="mb-4 text-center">📊 Статистика — <span className="text-info">{link.name}</span></h2>
            <div className="row g-4">
                <div className="col-md-6">
                    <Card className="shadow-sm border-0">
                        <CardBody>
                            <h5 className="text-muted">Переходы по времени</h5>
                            <ResponsiveContainer width="100%" height={400}>
                                <LineChart
                                    data={formattedData}
                                    margin={{ top: 20, right: 20, left: 20, bottom: 70 }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis
                                        dataKey="formattedTime"
                                        angle={-45}
                                        textAnchor="end"
                                        height={80}
                                    >
                                        <Label value="Дата и время" position="insideBottom" offset={-40} />
                                    </XAxis>
                                    <YAxis>
                                        <Label value="Клики" angle={-90} position="insideLeft" offset={10} />
                                    </YAxis>
                                    <Tooltip />
                                    <Line type="monotone" dataKey="clicks" stroke="#007bff" strokeWidth={2} />
                                </LineChart>
                            </ResponsiveContainer>
                        </CardBody>
                    </Card>
                </div>
                <div className="col-md-6">
                    <Card className="shadow-sm border-0">
                        <CardBody>
                            <h5 className="text-muted">Конверсия</h5>
                            <ResponsiveContainer width="100%" height={400}>
                                <PieChart>
                                    <Pie
                                        dataKey="value"
                                        data={[
                                            { name: "Кликнули", value: link.conversion.clicked },
                                            { name: "Игнорировали", value: link.conversion.ignored }
                                        ]}
                                        outerRadius={120}
                                        label
                                    >
                                        <Cell fill="#28a745" />
                                        <Cell fill="#dc3545" />
                                    </Pie>
                                    <Tooltip />
                                </PieChart>
                            </ResponsiveContainer>
                        </CardBody>
                    </Card>
                </div>
                <div className="col-md-6 col-lg-3">
                    <Card className="shadow-sm text-center h-100 border-0">
                        <CardBody>
                            <h6 className="text-muted">Всего переходов</h6>
                            <p className="display-6 text-primary fw-bold">{link.total_clicks}</p>
                        </CardBody>
                    </Card>
                </div>
                <div className="col-md-6 col-lg-3">
                    <Card className="shadow-sm text-center h-100 border-0">
                        <CardBody>
                            <h6 className="text-muted">Кликов по кнопке</h6>
                            <p className="display-6 text-success fw-bold">{link.button_clicks}</p>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </div>
    );
};
export default StatsPage;
